module.exports = __webpack_public_path__ + "img/jucai5.a7afabdd.jpg";